// 客资
export const API_CUSTOMER_LIST_V2 =
  '/p/wedding/Admin/APIMerchantCustomer/list_v2'
export const API_CUSTOMER_CHECK_EXIST =
  '/p/wedding/Admin/APIMerchantCustomer/check_exist'
export const API_CUSTOMER_STATUS = '/p/wedding/Admin/APIMerchantCustomer/status'
export const API_CUSTOMER_DETAIL_V2 =
  '/p/wedding/Admin/APIMerchantCustomer/detail_v2'
export const API_CUSTOMER_CREATE = '/p/wedding/Admin/APIMerchantCustomer/create'
export const API_CUSTOMER_MODIFY = '/p/wedding/Admin/APIMerchantCustomer/modify'
export const API_CUSTOMER_SOURCE_MAP =
  '/p/wedding/Admin/APIMerchantCustomer/sourceMapV3'
export const API_CUSTOMER_OPERATE_RECORD =
  '/p/wedding/Admin/APIMerchantCustomer/operate_record'
